const MORTGAGE_SCENARIO_ENDPOINTS = {
  LIST: "/frontend/mortgage-scenarios",
  CREATE: "/frontend/mortgage-scenarios",
  UPDATE: (id) => `/frontend/mortgage-scenarios/${id}`,
  REMOVE: (id) => `/frontend/mortgage-scenarios/${id}`,
  VIEW: (id) => `/frontend/mortgage-scenarios/${id}/view`,
};

export default MORTGAGE_SCENARIO_ENDPOINTS;
